module.exports = __webpack_public_path__ + "static/cutom-packaging-b8ec26d83022f0a0ad38f0cff333d0c3.svg";